import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getProfile } from "./redux/slices/profileSlice";
import {
  Login,
  LandingPage,
  Register,
  PrivateRoute,
  AdminRoute,
  AdminLayout,
  TermsOfService,
  PrivacyPolicy,
  WorkoutTemplate,
  ExerciseStats,
  SelectNewWorkoutType,
  SelectNewWorkoutTemplate,
  Blog,
  PasswordReset,
  PasswordSet,
  AnalyticsDashboard,
  EventsDashboard,
  PrescriptionsDashboard,
  FeedbackTriage,
  PurgeWorkouts,
  ResetAccount,
  CoachChats,
  CoachContext,
  WorkoutPublicContainer,
  WorkoutContainer
} from "./components/index.js";
import App from "./App.js";
import ViewWorkouts from "./components/Workout/ViewWorkouts";

function AppRoutes() {
  const dispatch = useDispatch();
  const { token } = useSelector((state) => state.authSlice);

  useEffect(() => {
    if (token) {
      dispatch(getProfile({ token: token }));
    }
  }, [dispatch, token]);

  return (
    <Router>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/welcome" element={<LandingPage />} />
        <Route path="/terms" element={<TermsOfService />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/" element={<PrivateRoute element={<App />} />} />
        <Route
          path="/workouts"
          element={<PrivateRoute element={<ViewWorkouts />} />}
        />
        <Route
          path="/workout/:workout_id"
          element={<PrivateRoute element={<WorkoutContainer/>}/>}
        />
        <Route
          path="/shared-workout/:pub_workout_id"
          element={<WorkoutPublicContainer/>}
        />
        <Route
          path="/workout-template/:workout_id"
          element={<PrivateRoute element={<WorkoutTemplate />} />}
        />
        <Route
          path="/stats/:exercise_name"
          element={<PrivateRoute element={<ExerciseStats />} />}
        />
        <Route
          path="/workout-type-select"
          element={<PrivateRoute element={<SelectNewWorkoutType />} />}
        />
        <Route
          path="/workout-template-select"
          element={<PrivateRoute element={<SelectNewWorkoutTemplate />} />}
        />
        <Route path="/forgot-password" element={<PasswordReset />} />
        <Route
          path="/set-password/:validation_code/:email"
          element={<PasswordSet />}
        />
        <Route
          path="/admin"
          element={<AdminRoute element={<AdminLayout />} />}
        >
          <Route index element={<Navigate to="/admin/usage" replace />} />
          <Route path="usage" element={<AnalyticsDashboard />} />
          <Route path="events" element={<EventsDashboard />} />
          <Route path="prescriptions" element={<PrescriptionsDashboard />} />
          <Route path="feedback-triage" element={<FeedbackTriage />} />
          <Route path="coach-chats" element={<CoachChats />} />
          <Route path="coach-context" element={<CoachContext />} />
          <Route path="purge-workouts" element={<PurgeWorkouts />} />
          <Route path="reset-account" element={<ResetAccount />} />
        </Route>
      </Routes>
    </Router>
  );
}

export default AppRoutes;
